import { render, staticRenderFns } from "./balanceWallet.vue?vue&type=template&id=3f983eb2&scoped=true&"
import script from "./balanceWallet.vue?vue&type=script&lang=js&"
export * from "./balanceWallet.vue?vue&type=script&lang=js&"
import style0 from "./balanceWallet.vue?vue&type=style&index=0&id=3f983eb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f983eb2",
  null
  
)

export default component.exports